/*
*   Start:      Wait for Element
*   Author:     Yong Wang
*   Ref:        https://stackoverflow.com/a/61511955
*   Desc:       A solution to run code only once an element is present.
*/
    function waitForElement(selector) {
        return new Promise(resolve => {
            if (document.querySelector(selector)) {
                return resolve(document.querySelector(selector));
            }

            const observer = new MutationObserver(mutations => {
                if (document.querySelector(selector)) {
                    observer.disconnect();
                    resolve(document.querySelector(selector));
                }
            });

            // If you get "parameter 1 is not of type 'Node'" error, see https://stackoverflow.com/a/77855838/492336
            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        });
    }
/*
*   End: Wait for Element
*/

/* - - - - - - - - - - - - - - - - - - - - */

/*
*   Start:          Globo Bed Options
*   Author:         mjdwebdesign
*   Description:    Updates a hidden "Globo Bed Sizes" option based on the "Bed Size" selected. This
*                   can then be used
*/
    function globoOptionsInit(){
        waitForElement('.globo-bed-sizes').then((element) => {
            const shopifyBedSizeSelect = document.querySelector('select[name="options[Bed Size]"]');
            const globoBedSizes = document.querySelector('.globo-bed-sizes');
            const globoBedSizesDropdownList = globoBedSizes.querySelector('.dropdown-list');
            const globoBedSizesInputs = globoBedSizesDropdownList.querySelectorAll('input');

            updateGloboBedSizes();

            shopifyBedSizeSelect.addEventListener('change', function(){
                updateGloboBedSizes();
            });

            function updateGloboBedSizes(){
                let shopifyBedSizeSelected = shopifyBedSizeSelect.value;
                globoBedSizesInputs.forEach(function(globoBedSizeInput){
                    if(shopifyBedSizeSelected == globoBedSizeInput.value || shopifyBedSizeSelected.includes(globoBedSizeInput.value)){
                        if(!globoBedSizeInput.checked){
                            setTimeout(function(){
                                globoBedSizeInput.click();
                            }, 500);
                        }
                        return;
                    }
                });
            }
        });
    }
/*
*   End: Globo Bed Options
*/

/* - - - - - - - - - - - - - - - - - - - - */

if(document.readyState === 'loading'){
    
    document.addEventListener('DOMContentLoaded', function(){
        globoOptionsInit();
    });

} else {

    globoOptionsInit();

}